import React from 'react';
import styles from './ButtonComponent.module.scss';
import { buttonVariants } from '../types';

export default function ButtonComponent({
  children,
  variant = buttonVariants.PRIMARY,
  action,
  text,
  classes,
  disabled = false
}) {
  const renderClass = (type) => {
    switch (type) {
      case buttonVariants.PRIMARY:
        return styles.primaryButton;
      case buttonVariants.SECONDARY:
        return styles.secondaryButton;
      case buttonVariants.ROUNDED:
        return styles.roundedButton;
      case buttonVariants.ROUNDED_NOTIFY_POSITIVE:
        return `${styles.roundedNotify} ${styles.roundedNotify_positive}`;
      case buttonVariants.ROUNDED_NOTIFY_NEGATIVE:
        return `${styles.roundedNotify} ${styles.roundedNotify_negative}`;
      case buttonVariants.ROUNDED_NOTIFY_PENDING:
        return `${styles.roundedNotify} ${styles.roundedNotify_pending}`;
      case buttonVariants.FULL_ROUNDED:
        return `${styles.fullRounded}`;
      default:
        return styles.primaryButton;
    }
  };

  return (
    <button className={`${classes} ${renderClass(variant)}`} onClick={action} disabled={disabled}>
      {children && <span className={styles.child}>{children}</span>}
      {text}
    </button>
  );
}
